export default __webpack_public_path__ + "static/media/zw.a53613c5.svg";